// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__36JmR","footer":"ModalFilter_footer__3aEMK"};